// no conflict
var $ = jQuery.noConflict();

$(document).ready(function () {
	// Sticky nav scroll logic
	$(window).on("scroll", function () {
		var sc = $(window).scrollTop();
		if (sc > 100) {
			$("#header").addClass("sticky-nav");
		} else {
			$("#header").removeClass("sticky-nav");
		}
	});

	// Run on page load
	var sc = $(window).scrollTop();
	if (sc > 100) {
		$("#header").addClass("sticky-nav");
	}

	// ✅ OPEN MODAL
	$("[data-modal-target]").on("click", function (e) {
		e.preventDefault();
		var modalId = $(this).data("modal-target");
		var $modal = $("#" + modalId);
		if ($modal.length) {
			$modal.removeClass("hidden");
		}
	});

	// ✅ CLOSE MODAL and stop media
	function closeModal($modal) {
		if ($modal.length) {
			$modal.addClass("hidden");

			// Pause <video> elements
			$modal.find("video").each(function () {
				this.pause();
				this.currentTime = 0;
			});

			// Stop <iframe> playback (e.g., YouTube)
			$modal.find("iframe").each(function () {
				var $iframe = $(this);
				var src = $iframe.attr("src");
				$iframe.attr("src", src);
			});
		}
	}

	// Close via button
	$(".closeModal").on("click", function () {
		var $modal = $(this).closest(".fixed");
		closeModal($modal);
	});

	// ✅ Close when clicking outside modal content
	$(".modal.fixed").on("click", function (e) {
		var $modalContent = $(this).children("div"); // first child = modal box
		if (
			!$modalContent.is(e.target) &&
			$modalContent.has(e.target).length === 0
		) {
			closeModal($(this));
		}
	});
});
